<template>
  <div style="position:relative">
    <div class="butt">
      <a-button @click="submit" type="primary" v-if="$auth('role.relevantDepartment')">保存</a-button>
      <a-button @click="reset" style="margin:0 10px">重置</a-button>
    </div>
    <a-spin :spinning="loading">
      <div ref="box" style="height:100%;overflow:auto;">
        <a-tree
          ref="tree"
          :treeData="treeData"
          checkable
          :autoExpandParent="autoExpandParent"
          @check="onCheck"
          @expand="onExpand"
          v-model="checkedKeys"
          :expandedKeys="expandedKeys"
        >
          <template slot="custom" slot-scope="role">
            <a-tooltip placement="topLeft" :title="role.departmentname">
              <span class="title-name">{{ role.departmentname }}</span>
            </a-tooltip>
          </template>
        </a-tree>
      </div>
    </a-spin>

  </div>
</template>

<script>
// import { getCompanyTree } from '@/api/organizationalStructure'
import { setDeptPermission, getDeptPermission, getRelevants } from '@/api/roleList.js'
export default {
  async mounted () {
    await this.initTree()
    await this.getRoleData()
  },
  data () {
    return {
      treeData: [],
      checkedKeys: [],
      expandedKeys: [],
      loading: false,
      autoExpandParent: true
    }
  },
  computed: {
    roleId () {
      return this.$store.state.role.roleId
    },
    roleName () {
      return this.$store.state.role.roleName
    }
  },
  watch: {
    roleId (id) {
      this.$nextTick(() => {
        this.$refs.box.scrollTop = 0
      })
      this.getRoleData()
    }
  },
  methods: {
    // 树结构
    async initTree () {
      this.loading = true
      const res = await getRelevants()
      // const res = {
      //   'data': [
      //     {
      //       'departmentname': '计量理化部',
      //       'deptId': 60,
      //       'ord43': null
      //     },
      //     {
      //       'departmentname': '能源管理部',
      //       'deptId': 27,
      //       'ord43': null
      //     },
      //     {
      //       'departmentname': '技术中心办公室',
      //       'deptId': 81,
      //       'ord43': null
      //     },
      //     {
      //       'departmentname': '办公室',
      //       'deptId': 21,
      //       'ord43': null
      //     },
      //     {
      //       'departmentname': '安全环保部',
      //       'deptId': 48,
      //       'ord43': null
      //     },
      //     {
      //       'departmentname': '信息管理部',
      //       'deptId': 85,
      //       'ord43': null
      //     }
      //   ],
      //   'status': 0,
      //   'info': {
      //     'message': '操作成功'
      //   }
      // }
      if (res && res.status === 0) {
        const loop = data => {
          for (let i = 0; i < data.length; i++) {
            // do
            // data[i].key = data[i].type === 1
            //   ? data[i].id + ''
            //   : 'dep' + data[i].id
            data[i].key = data[i].deptId
            data[i].scopedSlots = {
              title: 'custom'
            }
            if (data[i].children) {
              loop(data[i].children)
            }
          }
        }
        loop(res.data.list)
        this.treeData = res.data.list
        console.log(this.treeData)
      }
      this.loading = false
    },
    // 对应人员部门权限数据
    async getRoleData () {
      this.loading = true
      const params = { roleId: this.roleId }
      const res = await getDeptPermission(params)
      if (res && res.status === 0) {
        // this.checkedKeys = res.data.map(item => item.type === 2 ? `dep${item.deptId}` : `${item.deptId}`)
        this.checkedKeys = res.data.map(item => item.deptId)
        this.expandedKeys = this.getExpandedKeys()
      } else {
        this.$message.error(res.info.message)
      }
      this.loading = false
    },
    // 提交
    async submit () {
      if (this.checkedKeys.length === 0) {
        this.$message.warning('请至少选中一个部门')
        return
      }
      this.loading = true
      const params = {
        roleId: this.roleId,
        depts: this.checkedKeys.map(item => ({
          type: 2,
          deptId: item
        }))
      }
      const res = await setDeptPermission(params)
      if (res && res.status === 0) {
        this.$message.success(res.info.message)
      } else {
        this.$message.error(res.info.message)
      }
      this.loading = false
    },
    reset () {
      this.getRoleData()
    },
    // dfs 由选中数组得展开数组
    getExpandedKeys () {
      let arr = []
      const stack = []
      const loop = data => {
        for (let i = 0; i < data.length; i++) {
          // do
          if (this.checkedKeys.indexOf(data[i].key) !== -1) {
            arr = [...arr, ...stack]
          }
          stack.push(data[i].key)
          if (data[i].children) {
            loop(data[i].children)
          }
          stack.pop()
        }
      }
      loop(this.treeData)
      return Array.from(new Set(arr))
    },
    onCheck (checkedKeys, e) {
      console.log('onCheck', e)
      this.checkedKeys = checkedKeys
    },
    onExpand (expandedKeys, option) {
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .ant-tree.ant-tree-icon-hide {
  overflow-y: visible !important;
}
.butt {
  display:flex;
  position: absolute;
  top: 4px;
  left: 480px;

  // position: fixed;
  // top: 165px;
  // left: 800px;
  z-index: 100;
}
</style>
